var { Sidechain } = require("@nprapps/sidechain");
Sidechain.registerGuest();

let $ = require("./lib/qsa");

let resultElement = $.one(".result")

$.one(".calculator").addEventListener("input", recalculate);

recalculate();

function recalculate() {
  let year = 2027;//$.one(".tax-year input:checked")?.value * 1 || 2026;
  let amount = $.one(".property-value input").value.replace(/[\$,]/g, "") * 1 || 150000;
  
  let standard = year == 2026 ? 48000 : 40000;
  let supplemental = year == 2026 ? .4 : .46;

  let dollars = n => n.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  let remainder = amount - standard;
  let deduct = remainder * supplemental;
  if (deduct < 0) deduct = 0;
  let net = remainder - deduct;
  if (net < 0) net = 0;
  let rate = .372;
  let bill = net * rate / 100;

  resultElement.innerHTML = `
<table>
  <thead>
    <tr>
      <th>Category
      <th>
      <th class="numeric">Amount
  <tbody>
    <tr>
      <td>Property value
      <td>
      <td class="numeric">${dollars(amount)}
    <tr>
      <td>Standard deduction
      <td> -
      <td class="numeric">${dollars(standard)}
    <tr>
      <td>Supplemental deduction (${supplemental * 100}%)
      <td> -
      <td class="numeric">${dollars(deduct)}
    <tr>
      <td>Taxable value
      <td> =
      <td class="numeric">${dollars(net)}
    <tr>
      <td>Referendum tax rate
      <td> &times;
      <td class="numeric">$.372
    <tr class="total">
      <td>Total tax
      <td>
      <td class="numeric">${dollars(bill)}
</table>
  `;

}